import * as React from 'react';
import {  FormCheckbox} from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';
const CusFormCb = (props) => {

    const [checkedValue, setCheckedValue] = React.useState(props.checkedValue);
 
    const handleCheckedChange = async (event) => {
 
        setCheckedValue(event.value);
        await props.onCheckedChange(event.value,props);
    }

    return(
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <Field id={props.id}
                    name={props.id}
                    component={FormCheckbox}
                    checked={checkedValue}
                    onChange={handleCheckedChange} >
                    <span className={'k-checkbox-label'}>{props.lblname} </span>
            </Field>
          
        </div>
    )
}

export default CusFormCb;